import { NgModule } from '@angular/core';
import { IconModule } from 'src/app/components/icon/icon.module';

import { SharedModule } from '../../shared/shared.module';

import { NotificationItemComponent } from './notification-item.component';

@NgModule({
  imports: [IconModule, SharedModule],
  declarations: [NotificationItemComponent],
  exports: [NotificationItemComponent],
})
export class NotificationItemModule {}
